import { render, staticRenderFns } from "./DepositModal.vue?vue&type=template&id=53e25e5d&scoped=true&"
import script from "./DepositModal.vue?vue&type=script&lang=js&"
export * from "./DepositModal.vue?vue&type=script&lang=js&"
import style0 from "./DepositModal.vue?vue&type=style&index=0&id=53e25e5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e25e5d",
  null
  
)

export default component.exports